import { IOnInit } from "angular";
import { IQuery } from "../../../../../records/server/query";
import {
  MachineExportService,
  vsServiceName as MachineExportServiceName,
} from "../../../services/machineExportService";
import { GridConfiguration } from "../../../../../records/views/recordGridView";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { vsServiceName as MachineDetailTabsServiceName } from "../../../../shared/components/views/machines/detail/tabs";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../../../ui/authorizedUiElement";
import { MachineConfigurationView } from "../../../../shared/models/machineConfiguration";
import {
  ConversionModalService,
  vsServiceName as ConversionModalServiceName,
} from "../../../../shared/components/conversionModal";
import { StateService } from "@uirouter/angularjs";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../../shared/machineConfigurationCellClassService";
import { GridArgs } from "../../../../../records/grids/gridArgs";

export class MainMachinesGatewayComponentController implements IOnInit {
  static $inject = [
    MachineExportServiceName,
    ColumnDefinitionServiceName,
    MachineDetailTabsServiceName,
    ConversionModalServiceName,
    "$state",
    MachineConfigurationCellClassServiceName,
  ];

  readonly defaultQuery: IQuery = {
    CurrentConfiguration: true,
    Statuss: "Warehoused,Floor",
  };

  currentConfiguration: boolean = true;
  readonly gridConfiguration!: GridConfiguration;

  gridSelection: MachineConfigurationView[] = [];

  constructor(
    private readonly machineExportService: MachineExportService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>,
    private readonly conversionModalService: ConversionModalService,
    private readonly $state: StateService,
    private readonly machineConfigurationCellClassService: MachineConfigurationCellClassService
  ) {}

  $onInit(): void {
    this.gridConfiguration.gridDataSource!.query = this.defaultQuery;
    this.gridConfiguration.columns = [
      this.columnDefinitionService.getSelectColDef({
        headerName: "Select",
      }),
      this.columnDefinitionService.getLinkColDef({
        headerName: "detail",
        iconClass: "fa fa-info-circle text-primary",
        colId: "detail",
        width: 20,
        stateExpression: `${this.machineDetailTabsService.getSrefByIndex(
          0
        )}({ machineId: data.MachineId})`,
      }),
      this.columnDefinitionService.getLinkColDef({
        headerName: "edit",
        iconClass: "fa fa-pencil text-primary",
        colId: "edit",
        stateExpression:
          "main.machines.detail.edit({machineId: data.MachineId, machineConfigurationId: data.MachineConfigurationId})",
        requiresPermission: "machineEdit",
      }),
      ...(this.gridConfiguration.columns ?? []),
    ];
    this.applyStyles();
  }

  gridSelectionChanged(
    data: MachineConfigurationView,
    selected: boolean,
    selectedIds: number[]
  ) {
    const selectedItems = this.gridSelection;
    if (selected) {
      selectedItems.push(data);
    }
    this.gridSelection = selectedItems.filter((si) =>
      selectedIds.includes(si.Id)
    );
  }

  includeDecommissionedChanged(includeDecommissioned: boolean) {
    if (includeDecommissioned) {
      this.defaultQuery.Statuss = undefined;
    } else {
      this.defaultQuery.Statuss = "Warehoused,Floor";
    }
  }
  currentConfigurationChanged(currentConfiguration: boolean) {
    this.applyStyles();

    if (currentConfiguration) {
      this.defaultQuery.CurrentConfiguration = true;
    } else {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  private applyStyles() {
    this.machineConfigurationCellClassService.styleColumns(
      this.gridConfiguration.columns,
      !this.currentConfiguration
    );
  }

  olgDownload() {
    return this.machineExportService.assetMatrixDownload(this.getExportQuery());
  }

  sdsDownload() {
    return this.machineExportService.slotfileDownload(this.getExportQuery());
  }

  getExportQuery() {
    return {
      ...this.gridConfiguration.gridSettings!.getQuery(),
      ...this.defaultQuery,
    };
  }

  childDisabled(child: AuthorizedUiElementConfig) {
    const selectedMachines = this.gridSelection.length;
    if (selectedMachines < 2) return false;

    return child.id === "clone" || child.id === "conversion";
  }

  childClicked(
    child: AuthorizedUiElementConfig,
    childService: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {
    switch (child.id) {
      case "clone":
        const machineId = this.gridSelection[0].MachineId;
        const machineConfigurationId = this.gridSelection[0].Id;
        childService.navigateToChild(child, {
          modelMachineId: machineId,
          modelMachineConfigurationId: machineConfigurationId,
        });
        break;
      case "conversion":
        const selectedMachineConfigurationView = this.gridSelection.at(0)!;
        const modalInstance = this.conversionModalService.openModal();
        modalInstance.result.then((result) => {
          return childService.navigateToChild(child, {
            machineId: selectedMachineConfigurationView.MachineId,
            modelMachineId: result.machineId,
            modelMachineConfigurationId: result.machineConfigurationId,
          });
        });
        break;
      default:
        const sref = childService.getSref(child);
        this.$state.go(sref, {
          machineConfigurations: this.gridSelection,
        });
    }
  }
}
